import { Box, Button } from "@mui/material";
import React from "react";
import SubTabNoData from "../components/console_page/sub_tab/SubTabNoData";
import '../CSS/private/NoProjectPage.css';
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";

function NoProjectPageTemplate(props) {

  const appBar = props.appBar;
  const userData = props.userData;
  var admin = false;
  userData.organisations.forEach((organisation) => {
    if(organisation.id === userData.active_organisation_id) {
      admin = organisation.admin;
    }
  })

  const clonedAppBar = React.cloneElement( appBar, { userData: userData });

  return (
    <Box sx={{ display: 'flex' }}>
      {clonedAppBar}
      <div className={'slp-no-project-page'}>
        <SubTabNoData 
          icon={faFolderOpen} 
          title={
            props.organisationData 
            ? `No Projects`
            : `No Organisations`
          }
          description={
            props.organisationData 
            ? `No active projects found for current organisation (${userData.active_organisation_id})`
            : `Organisations are invite-only. Contact admin to request an invite`
          }
        />
        <br />
        {userData.organisations.length > 1? 
          <Button>Change Organisation</Button>
        : null}
        {admin? (
          <Box sx={{display: 'flex', flexDirection: 'column', justify: 'start'}}>
            <Button onClick={() => window.location.replace('/admin-console')}>Go To Admin Console</Button>
          </Box>
        ) : null}
      </div>
    </Box>
  )
}

export default NoProjectPageTemplate